export const MODULES_FETCH = 'MODULES_FETCH'
export const MODULES_FETCH_SUCCESS = 'MODULES_FETCH_SUCCESS'
export const MODULES_FETCH_FAILED = 'MODULES_FETCH_FAILED'

export const CREATE_MODULE = 'CREATE_MODULE'
export const CREATE_MODULE_SUCCESS = 'CREATE_MODULE_SUCCESS'
export const CREATE_MODULE_FAILED = 'CREATE_MODULE_FAILED'

export const DELETE_MODULE = 'DELETE_MODULE'
export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS'
export const DELETE_MODULE_FAILED = 'DELETE_MODULE_FAILED'

export const UPDATE_MODULE = 'UPDATE_MODULE'
export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS'
export const UPDATE_MODULE_FAILED = 'UPDATE_MODULE_FAILED'

export const RESET_MODULE_NOTIFICATION = 'RESET_MODULE_NOTIFICATION'

export const CREATE_CARD = 'CREATE_CARD'
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS'
export const CREATE_CARD_FAILED = 'CREATE_CARD_FAILED'

export const UPDATE_CARD = 'UPDATE_CARD'
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS'
export const UPDATE_CARD_FAILED = 'UPDATE_CARD_FAILED'

export const DELETE_CARD = 'DELETE_CARD'
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS'
export const DELETE_CARD_FAILED = 'DELETE_CARD_FAILED'

export const CHANGE_MODULE = 'CHANGE_MODULE'

export const GET_ROLLUP = 'GET_ROLLUP'
export const GET_ROLLUP_SUCCESS = 'GET_ROLLUP_SUCCESS'
export const GET_ROLLUP_FAILED = 'GET_ROLLUP_FAILED'

export const REORDER_MODULES = 'REORDER_MODULES'

export const SHEETS_FETCH = 'SHEETS_FETCH'
export const SHEETS_FETCH_SUCCESS = 'SHEETS_FETCH_SUCCESS'
export const SHEETS_FETCH_FAILED = 'SHEETS_FETCH_FAILED'

export const EXCEL_FETCH = 'EXCEL_FETCH'
export const EXCEL_FETCH_SUCCESS = 'EXCEL_FETCH_SUCCESS'
export const EXCEL_FETCH_FAILED = 'EXCEL_FETCH_FAILED'

export const SHEETS_RESET = 'SHEETS_RESET'

export const COPY_CARD = 'COPY_CARD'
export const COPY_CARD_SUCCESS = 'COPY_CARD_SUCCESS'
export const COPY_CARD_FAILED = 'COPY_CARD_FAILED'

export const RENAME_CARD_FETCH = 'RENAME_CARD_FETCH'
export const RENAME_CARD_SUCCESS = 'RENAME_CARD_SUCCESS'
export const RENAME_CARD_FAILED = 'RENAME_CARD_FAILED'
